<div class="flex items-center gap-3 px-3 py-2.5">
  <!-- Mini-aperçu de la grille de la planche (cases occupées / vides) -->
  <div class="grid shrink-0 gap-[2px]"
    [style.grid-template-columns]="'repeat(' + cols + ', 1fr)'"
    [style.width.px]="gridWidthPx">
    @for (cell of cells; track $index) {
      @if (cell.occupied) {
        <span class="aspect-square rounded-[3px] bg-[#63AE81]"></span>
      } @else {
        <span class="aspect-square rounded-[3px] border border-dashed border-[#C4CAC7]"></span>
      }
    }
  </div>

  <!-- Nom + dimensions + résumé -->
  <div class="min-w-0 flex-1">
    <p class="truncate text-sm font-semibold text-[#023E42]">
      {{ bed.name }}
      <span class="font-normal text-[#C4CAC7]">·</span>
      <span class="text-xs font-medium text-[#9DA4A2]">{{ dimensionLabel }}</span>
    </p>
    <p class="text-[11px] text-[#9DA4A2]">
      🌱 {{ 'garden.overview.plants-count' | translate: { count: plantCount } }} · {{ 'garden.overview.free-cells' | translate: { count: freeCells } }}
    </p>
  </div>

  <!-- Badge « action attendue » (composant réutilisable, identique partout) -->
  @if (actionNeeded) {
    <vw-action-badge class="shrink-0" [ariaLabel]="'garden.overview.action-todo' | translate"></vw-action-badge>
  }

  <!-- Chevron -->
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9BA6A1" stroke-width="2"
    stroke-linecap="round" stroke-linejoin="round" class="shrink-0">
    <path d="M9 6l6 6-6 6" />
  </svg>
</div>
